import '../scss/collection.scss';
import { defaultSortBy } from '../components/sort-by';
import { rangeFilters } from '../components/filters-range';
import { setupCustomSelect } from '../components/custom-select';
import { initFilter } from '../utils/filter-navigation';
import { initCollectionNavSticky } from '../components/collection-navigation';

window.addEventListener('DOMContentLoaded', () => {
  defaultSortBy();
  rangeFilters();
  setupCustomSelect();
  initFilter();
  initCollectionNavSticky();
})
